<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <div class="info-container"><mat-icon matTooltip="The password needs to have a minimum of eight characters, at least one letter, one number and one special
        character.">info</mat-icon></div>
    <form [formGroup]="form" autocomplete="off" class="container">
        <mat-form-field appearance="outline" autocomplete="off" class="form-field">
            <mat-label>New Password</mat-label>
            <input *ngIf="isPasswordVisible" type="text" autoComplete="off" matInput formControlName="password">
            <input *ngIf="!isPasswordVisible" type="password" autoComplete="off" matInput formControlName="password">
            <mat-icon *ngIf="!isPasswordVisible" title="Show Password" matSuffix class="visibility"
                (click)="visibilityPassword()">
                visibility</mat-icon>
            <mat-icon *ngIf="isPasswordVisible" title="Hide Password" matSuffix class="visibility"
                (click)="visibilityPassword()">
                visibility_off</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" autocomplete="off" class="form-field">
            <mat-label>Repeat New Password</mat-label>
            <input *ngIf="isPasswordRepeatVisible" type="text" autoComplete="off" matInput onpaste="return false;"
                ondrop="return false;" formControlName="passwordRepeat">
            <input *ngIf="!isPasswordRepeatVisible" type="password" autoComplete="off" matInput onpaste="return false;"
                ondrop="return false;" formControlName="passwordRepeat">
            <mat-icon *ngIf="!isPasswordRepeatVisible" title="Show Password" matSuffix class="visibility"
                (click)="visibilityPasswordRepeat()">
                visibility</mat-icon>
            <mat-icon *ngIf="isPasswordRepeatVisible" title="Hide Password" matSuffix class="visibility"
                (click)="visibilityPasswordRepeat()">
                visibility_off</mat-icon>
        </mat-form-field>
        <div *ngIf="errors.length > 0" class="validation-status">
            <p *ngFor="let error of errors">{{error}}</p>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button class="color" (click)="cancel()">{{button1}}</button>
    <span class="spacer"></span>
    <button mat-button class="color" (click)="overridePassword()" cdkFocusInitial>{{button2}}</button>
</mat-dialog-actions>